var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrendUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M.96 14.874a1 1 0 0 0 1.414 0l4.057-4.058.236-.232.027.026c.058.056.124.122.208.207l2.281 2.28.021.022c.147.146.296.296.434.413.154.13.358.278.629.366.368.12.765.12 1.133 0a1.9 1.9 0 0 0 .628-.366c.138-.117.288-.267.434-.413l4.871-4.871v3.419a1 1 0 1 0 2 0V5.833a1 1 0 0 0-1-1H12.5a1 1 0 1 0 0 2h3.42l-4.851 4.85-.236.233-.027-.026-.208-.207-2.281-2.28-.021-.022a8 8 0 0 0-.434-.413 1.9 1.9 0 0 0-.629-.366 1.83 1.83 0 0 0-1.133 0 1.9 1.9 0 0 0-.628.366 8 8 0 0 0-.434.413l-.021.021L.96 13.46a1 1 0 0 0 0 1.414",
  clipRule: "evenodd"
})));
SvgTrendUp.displayName = "SvgTrendUp";
export { SvgTrendUp as ReactComponent };
export default SvgTrendUp;